/* eslint-disable */
!(function (o) {
    const n = (o.ru = o.ru || {});

    n.dictionary = Object.assign(n.dictionary || {}, {
        "Line Height": "Межстрочный интервал",
    });
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {}));
